import styled from 'styled-components';

import shopImg from '../../assets/shop.png';

export const Container = styled.div`
  height: 100vh;

  display: flex;
  align-items: stretch;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  place-content: center;

  width: 100%;
  max-width: 700px;

  h1 {
    font-family: 'Roboto Condensed';
    font-weight: 600;
    font-size: 54px;
    line-height: 63px;

    color: #2c73e9;
  }

  form {
    margin: 38px 0;
    width: 340px;
    text-align: center;
  }
`;

export const Background = styled.div`
  flex: 1;
  background: url(${shopImg}) no-repeat center;
  background-size: auto;
`;
